import React, { useEffect, useState } from 'react';
import { useParams,Link } from "react-router-dom"

    //const url99 = "/backend/Qr_Check";
    //fetch(url99)
    //  .then((response) => response.json())
    //  .then((data) => {
    //    console.log(data);
    //    console.log(Array.isArray(data));
    //  });


const Qr_Check = () => {
  return (
    <div>
      <h1>Qr_Check 결과</h1>
      <p>Qr_Check 내용</p>
    </div>
  );
};

export default Qr_Check;